import { useEffect } from 'react';

/**
 * Helper component to set meta titles, meta descriptions,
 * OpenGraph and Twitter card metadata for each page.
 */
export default function SEO({ title, description, ogTitle, ogDescription, ogImage }) {
  useEffect(() => {
    // 1. Set document title
    if (title) {
      document.title = title;
    }

    // Helper function to update or create head meta tags
    const setMetaTag = (attrName, attrValue, content) => {
      if (!content) return;
      let tag = document.querySelector(`meta[${attrName}="${attrValue}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute(attrName, attrValue);
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', content);
    };

    const finalOgTitle = ogTitle || title;
    const finalOgDesc = ogDescription || description;
    const defaultImage = 'https://assets.auxodev.dk/assets/c7c56c0a-0dd8-4ac4-b9ee-4da1caafe85f/edfc4191-0236-4b5a-915a-2a04051a9ea3.jpg';
    const finalImage = ogImage || defaultImage;

    // Standard Meta Description
    setMetaTag('name', 'description', description);

    // Open Graph Meta
    setMetaTag('property', 'og:title', finalOgTitle);
    setMetaTag('property', 'og:description', finalOgDesc);
    setMetaTag('property', 'og:image', finalImage);
    setMetaTag('property', 'og:type', 'website');

    // Twitter Meta
    setMetaTag('name', 'twitter:card', 'summary_large_image');
    setMetaTag('name', 'twitter:title', finalOgTitle);
    setMetaTag('name', 'twitter:description', finalOgDesc);
    setMetaTag('name', 'twitter:image', finalImage);

  }, [title, description, ogTitle, ogDescription, ogImage]);

  return null;
}
